import { INCONSISTENCY_RULES, RULE_GROUP_META } from "./inconsistencyRules";

// Sentinela do filtro por grupo: não é um grupo do catálogo, é a ausência de
// recorte. Fica aqui porque o domínio é quem sabe interpretá-la.
export const ALL_GROUPS = "all";

const REDMINE_ISSUES_URL = "https://redmine.coopersystem.com.br/issues";

const TYPE_LABELS = {
  task: "Tarefa",
  sprint: "Sprint",
  documentation: "Documento",
};

export function classify(item) {
  const description = item?.description;
  if (!description) return null;

  return INCONSISTENCY_RULES.find((rule) => rule.match(description)) || null;
}

export function countByRule(items) {
  const counts = new Map(INCONSISTENCY_RULES.map((rule) => [rule.id, 0]));

  (items || []).forEach((item) => {
    const rule = classify(item);
    if (rule) counts.set(rule.id, counts.get(rule.id) + 1);
  });

  return counts;
}

// O total conta tudo que foi apurado; os subtotais, só o que foi
// classificado. Ocorrência que nenhuma regra casa existe em dados reais
// (§3.4) e some do agrupamento — escondê-la do total encolheria a auditoria.
export function summarize(items) {
  const list = items || [];
  const byRule = countByRule(list);
  const byGroup = Object.fromEntries(Object.keys(RULE_GROUP_META).map((group) => [group, 0]));

  INCONSISTENCY_RULES.forEach((rule) => {
    byGroup[rule.group] += byRule.get(rule.id);
  });

  return { total: list.length, byGroup, byRule };
}

// Filtra pela regra vencedora, não pelo substring: é o que faz a contagem da
// tabela e o tamanho da lista de ocorrências serem sempre o mesmo número.
export function filterByRule(items, ruleId) {
  if (!ruleId) return items || [];
  return (items || []).filter((item) => classify(item)?.id === ruleId);
}

// Duas faixas de propósito: a coluna diz se a regra tem algo a corrigir, e o
// volume continua sendo papel da coluna de ocorrências.
export function ruleStatus(count) {
  return count > 0
    ? { label: "Com ocorrências", pill: "attention" }
    : { label: "Sem ocorrências", pill: "none" };
}

export function sortRulesByCount(byRule) {
  // Ordenação estável desde o ES2019: o empate cai na ordem canônica do
  // catálogo, que é a mesma precedência usada para classificar.
  return INCONSISTENCY_RULES.map((rule) => ({ rule, count: byRule.get(rule.id) ?? 0 })).sort(
    (a, b) => b.count - a.count,
  );
}

export function filterRowsByGroup(rows, group) {
  if (group === ALL_GROUPS) return rows || [];
  return (rows || []).filter(({ rule }) => rule.group === group);
}

export function occurrenceCountLabel(count) {
  return count === 1 ? "1 ocorrência" : `${count} ocorrências`;
}

export function extractIssueId(description) {
  const match = typeof description === "string" ? description.match(/\((\d+)\)/) : null;
  return match ? match[1] : null;
}

// Ponto único do link da ocorrência: a tela legada renderizava dois âncoras
// para a mesma tarefa porque a decisão estava duplicada no JSX.
export function issueUrl(item) {
  if (item?.url) return item.url;

  const issueId = extractIssueId(item?.description);
  return issueId ? `${REDMINE_ISSUES_URL}/${issueId}` : null;
}

// O backend também usa `type` para carregar o assunto da tarefa, que não
// cabe numa pill: só os três valores catalogados viram rótulo.
export function typeLabel(type) {
  return TYPE_LABELS[type] || "Inconsistência";
}
